import { OverviewReelView } from "./overview-reel";
import { OverviewReelModel } from "../models/overview-reel";
import { backboneViewProperties } from "../../decorators/backbone-properties";

@backboneViewProperties({
    tagName: "div",
    className: "ovewview-reels",
    childView: OverviewReelView
})
export class OverviewReelsView extends Marionette.CollectionView<OverviewReelModel, OverviewReelView> {

    public constuctor(options?) {
        // 
    }

    public onShow() {
        this.collection.each((model) => {
            model.trigger("updateDisplay");
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/overview-reels.ts